import { getListDefaultState }                              from 'ClientService';
import { useSubject }                                       from 'ClientService/HookApi';
import ModuleSelect                                         from 'Common/ModuleSelect/ModuleSelect';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector }                         from 'react-redux';
import {
  getIndicatorIds, getModuleByName,
  isIndicatorIdsLoading
} from 'Redux/Query';
import { debounceTime, takeUntil }                          from 'rxjs/operators';
import { findIndicatorIdsRequest }                          from 'Redux/Action';
import Transfer                                             from 'Common/Transfer/Transfer';

export const IndicatorIdTransfer = ({ value, defaultValue, onChange }) => {

  const dispatch = useDispatch();
  const { filter } = getListDefaultState({});

  let _defaultValue = defaultValue ?? [];
  _defaultValue     = Array.isArray(_defaultValue) ? _defaultValue : [ _defaultValue ] || [];

  const [ targetKeys, setTargetKeys ] = useState(_defaultValue);
  const [ module, setModule ] = useState(null);
  const getModule = useSelector(getModuleByName);

  const onDestroy$ = useSubject(() => {});
  const onSearch$ = useSubject((value) => {
    const filterProps = {
      sorting   : { field: '`Result`.`indicator_id`', order: 'ASC' },
      pagination: { page: 1, take: 2000 }
    };
    if(module) {
      filterProps.filter = [ { field: '`Result`.`module`', value: module.name } ];
    }
    if (!value || `${value}`.trim() === '') {
      return dispatch(findIndicatorIdsRequest(filterProps));
    }
    dispatch(findIndicatorIdsRequest({
      filter: [
        ...(filterProps?.filter || []),
        { field: '`Result`.`indicator_id`', value: `%${value}%` }
      ],
      ...filterProps,
    }));
  }, [module], takeUntil(onDestroy$), debounceTime(500));

  const indicatorIds = useSelector(getIndicatorIds);
  const isLoading    = useSelector(isIndicatorIdsLoading);

  useEffect(() => {
    const moduleFilter = filter.find(({ field }) => field === 'subModule');
    if (!moduleFilter) {
      return;
    }
    const _module = getModule(moduleFilter.value);
    if(_module && !module) {
      setModule(_module);
    }
  }, [filter]);

  useEffect(() => {
    if(!module) {
      return;
    }
    onSearch$.next();
  }, [module])

  const handleOnChange = useCallback((targetKeys) => {
    setTargetKeys(targetKeys);
    if (onChange && typeof onChange === 'function') {
      onChange(targetKeys);
    }
  }, []);

  const handleOnSearchCareProvider = useCallback((direction, value) => {
    if (direction === 'right') {
      return;
    }
    onSearch$.next(value);
  }, []);

  const handleOnChangeModule = (value) => {
    setModule(value);
  };

  useEffect(() => {
    if (!value) {
      return;
    }
    setTargetKeys(value);
  }, [ value ]);

  useEffect(() => {
    onSearch$.next();

    return () => {
      onDestroy$.next();
      onDestroy$.complete();
    };
  }, []);

  const dataSource = useMemo(() => {
    return [ ...new Set([ ...indicatorIds ].concat(targetKeys)) ];
  }, [ indicatorIds, targetKeys ]);


  return (
    <>
      <ModuleSelect onChange={handleOnChangeModule} value={module} />
      <br/><br/>
      <Transfer
        isLoading={isLoading}
        header={[ 'Verfügbare Kennzahlen', 'Ausgewählte Kennzahlen' ]}
        dataSource={dataSource.map(indicatorId => ({
          key  : indicatorId,
          title: indicatorId,
        }))}
        targetKeys={targetKeys}
        locale={{
          itemUnit       : 'Kennzahl',
          itemsUnit      : 'Kennzahlen',
          notFoundContent: 'Keine Kennzahlen gefunden',
        }}
        onChange={handleOnChange}
        onSearch={handleOnSearchCareProvider}
        filterOption={(input, { title }) => `${title}`.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        showSearch
        listStyle={{ height: 400 }}
        render={item => `${item.title}`}
        operations={[ 'zuordnen', 'entfernen' ]}
      />
    </>

  );

};
